import type React from 'react';
import { IconAddressBook, IconMessage, IconSettings } from '@tabler/icons-react';
import { IconExploreRounded } from '@shared/ui/IconExploreRounded';

export type ActiveTab = 'chats' | 'contacts' | 'plaza' | 'settings';

export type WorkspaceNavigationItem = {
  value: ActiveTab;
  label: string;
  ariaLabel: string;
  icon: React.ReactNode;
  badge?: number;
};

type WorkspaceNavigationItemOptions = {
  totalUnreadCount: number;
  pendingRequestCount: number;
  iconSize?: number;
};

export function getWorkspaceNavigationItems({
  totalUnreadCount,
  pendingRequestCount,
  iconSize = 18,
}: WorkspaceNavigationItemOptions): WorkspaceNavigationItem[] {
  return [
    {
      value: 'chats',
      label: '消息',
      ariaLabel: '打开消息',
      icon: <IconMessage size={iconSize} />,
      badge: totalUnreadCount,
    },
    {
      value: 'contacts',
      label: '联系人',
      ariaLabel: '打开联系人',
      icon: <IconAddressBook size={iconSize} />,
      badge: pendingRequestCount,
    },
    {
      value: 'plaza',
      label: 'Hubs',
      ariaLabel: '打开 Hubs',
      icon: <IconExploreRounded size={iconSize} />,
    },
    {
      value: 'settings',
      label: '设置',
      ariaLabel: '打开设置',
      icon: <IconSettings size={iconSize} />,
    },
  ];
}
